import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Converts a UTC ISO string or Date to a human-readable date in a given offset.
 *
 * @param date - The input date (UTC).
 * @param offset - A string like '-07:00'.
 * @returns A formatted date string.
 */
export const formatDateToReadable = (
  date: string | Date,
  offset = '-07:00',
): string => {
  if (!date) return '';
  const d = dayjs(date);
  if (!d.isValid()) return '';
  return d.utcOffset(offset).format('MMMM D, YYYY');
};
